import { Injectable } from '@angular/core';
import { RequestOptions, Response, URLSearchParams } from '@angular/http';

import { AuthHttp } from '../../../../../common/index';
import { AppSettings } from '../../../../../settings/index';

@Injectable()
export class ContractDetailsService {
    constructor(private http: AuthHttp) { }

     getContractDetailsWithChargeDescriptionByOwnerDivision(ownerCode: string, divisionCode: string, serviceType: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set('ownerCode', ownerCode);
        params.set('divisionCode', divisionCode);
        params.set('serviceType', serviceType);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + 'ContractDetails/GetContractDetailsWithChargeDescriptionByOwnerDivision', options)
            .map((response: Response) => response.json());
    }
}


// WEBPACK FOOTER //
// ./src/app/infrastructure/services/transaction/op/outbound/order/contract-details.service.ts